var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowWeDoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0293 0H23.3822L32.6469 11.4706H20.7352L11.0293 0Z",
    fill: "#003B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5879 30H22.9408L32.2055 18.5294H20.2938L10.5879 30Z",
    fill: "#003B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5883L32.2059 11.0294L36.1765 15L32.2059 18.5294H0V10.5883Z",
    fill: "#003B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowWeDoArrow);
export default __webpack_public_path__ + "static/media/HowWeDOArrow.46efc7efce6d04f617d54c61cb234e17.svg";
export { ForwardRef as ReactComponent };